import { Component, OnInit, OnDestroy, HostListener, ViewChild, AfterViewInit, TemplateRef } from '@angular/core';
//import {FormBuilder} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Module } from '../shared/model/module.model';
// import {PatientInformation} from '../patient-information-list/model/patient-information.model';
// import {PatientInformationDetailsService} from './service/patient-information-details.service';
import { Subscription } from 'rxjs';
import { FeaturedHomeService } from './featured-home.service';
import {AuthService} from '../shared/auth/auth.service';
import { environment } from '../../environments/environment';
import { SwiperComponent } from '../../../node_modules/angular2-useful-swiper';
import { UserQuota } from 'app/shared/model/userquota.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { BreezeService } from 'app/shared/service/breeze.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'featuredhomemodules',
  templateUrl: './featured-home.component.html'
})
export class FeaturedHomeComponent implements OnInit, OnDestroy {
  paramSub: Subscription;
  modules: Module[];
  breezeSessionString: string;
  public screenWidth: any;
  moduleNum: number;

  restrictedStoreList: number[] = [6732,6733,6737,6797,6827,6809,6789,6869,6851,6998,6799,7081,6824,6771,6786,6925,6787,6777,6985,6946,6762];
  foundRestrictedModule: boolean = false;
  foundPharmacistModule: boolean = false;

  isSupplier: boolean = false;

  paramSubQuotaSession: Subscription;
  userQuota: UserQuota = new UserQuota();
  sessionFlag: boolean = false;
  quotaFlag: boolean = false;
  public modalRef: BsModalRef; 

  @ViewChild('modalSession') modalSessionTemp: TemplateRef<any>;
  @ViewChild('modalQuota') modalQuotaTemp: TemplateRef<any>;


 // baseSystem = environment.baseSystem;
  // config: any = {
  //   pagination: '.swiper-pagination',
  //   paginationClickable: true,
  //   nextButton: '.swiper-button-next',
  //   prevButton: '.swiper-button-prev',
  //   slidesPerView: 4,
  //   slidesPerColumn: 2,
  //   spaceBetween: 30

  // };

  config: any = {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.swiper-button-next2',
    prevButton: '.swiper-button-prev2',
    slidesPerView: 4,
    slidesPerColumn: 2,
    spaceBetween: 30

  };

  config1: any = {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.swiper-button-next2',
    prevButton: '.swiper-button-prev2',
    slidesPerView: 4,
    slidesPerColumn: 2,
    spaceBetween: 30

  };

  config2: any = {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.swiper-button-next2',
    prevButton: '.swiper-button-prev2',
    slidesPerView: 1,
    slidesPerColumn: 1,
    spaceBetween: 30

  };


  @HostListener('window:resize', ['$event'])
  onResize(event){
    this.screenWidth = window.innerWidth;
    console.log(this.screenWidth + "Change screen width");

    if(this.screenWidth <= 500){
      this.usefulSwiper.config = this.config2;
      this.usefulSwiper.initialize = true;
      this.config = this.config2;
      this.usefulSwiper.Swiper.params.slidesPerView=1;
      this.usefulSwiper.Swiper.params.slidesPerColumn=1;

      this.usefulSwiper.Swiper.update();

      console.log(this.screenWidth + "useful Swiper 2 width");
    }else if (this.screenWidth > 500 && this.screenWidth <= 700) {
      this.usefulSwiper.config = this.config;
      this.usefulSwiper.initialize = true;
      this.config = this.config1;
      this.usefulSwiper.Swiper.params.slidesPerView=2;
      this.usefulSwiper.Swiper.params.slidesPerColumn=2;
      this.usefulSwiper.Swiper.update();
      console.log(this.usefulSwiper.Swiper + "useful Swiper 2 width");
    }else if (this.screenWidth > 700) {
      this.usefulSwiper.config = this.config;
      this.usefulSwiper.initialize = true;
      this.config = this.config1;
      this.usefulSwiper.Swiper.params.slidesPerView=4;
      this.usefulSwiper.Swiper.params.slidesPerColumn=2;
      this.usefulSwiper.Swiper.update();
      console.log(this.usefulSwiper.Swiper + "useful Swiper 2 width");
    }

  }

  @ViewChild('usefulSwiper') usefulSwiper: SwiperComponent;

  constructor(private _route: ActivatedRoute,
    private _router: Router,
    private featuredHomeService: FeaturedHomeService,
    private breezeService: BreezeService,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    public authService:AuthService) {
  }

  ngAfterViewInit(){

    this.screenWidth = window.innerWidth;
    console.log(this.screenWidth + "Change screen width on INIT");

    if(this.screenWidth <= 500){
      this.usefulSwiper.config = this.config2;
      this.usefulSwiper.initialize = true;
      this.config = this.config2;
      this.usefulSwiper.Swiper.params.slidesPerView=1;
      this.usefulSwiper.Swiper.params.slidesPerColumn=1;

      this.usefulSwiper.Swiper.update();

      console.log(this.screenWidth + "useful Swiper 2 width");
    }else if (this.screenWidth > 500 && this.screenWidth <= 700) {
      this.usefulSwiper.config = this.config;
      this.usefulSwiper.initialize = true;
      this.config = this.config1;
      this.usefulSwiper.Swiper.params.slidesPerView=2;
      this.usefulSwiper.Swiper.params.slidesPerColumn=2;
      this.usefulSwiper.Swiper.update();
      console.log(this.usefulSwiper.Swiper + "useful Swiper 2 width");
    }else if (this.screenWidth > 700) {
      this.usefulSwiper.config = this.config;
      this.usefulSwiper.initialize = true;
      this.config = this.config1;
      this.usefulSwiper.Swiper.params.slidesPerView=4;
      this.usefulSwiper.Swiper.params.slidesPerColumn=2;
      this.usefulSwiper.Swiper.update();
      console.log(this.usefulSwiper.Swiper + "useful Swiper 2 width");
    }

  }
  ngOnInit() {
    this.screenWidth = window.innerWidth;


    if (this.authService.getUserData() != null && this.authService.getUserData().supplierAccess == true) {
      this.isSupplier = true;
    }

    if(this.authService.getUserData() != null && this.authService.getUserData().profession == 'Pharmacist'){
      this.foundPharmacistModule = true;
    }
    

    this.featuredHomeService.getHomeModules().subscribe(
      modules => {
        this.modules = modules;
        console.log("inside this.featuredHomeService.getHomeModules()");
        for(let i = 0; i < modules.length; i++) {
        console.log(modules[i].vimage);
        console.log(modules[i].trStatus);
        console.log(modules[i].icourseID);

          
        //PHARMACIST RESTRICTION
        if(this.foundPharmacistModule == false && (modules[i].icourseID == 18913571 ||  modules[i].icourseID== 25904668) ){  // Add scoId here for Pharmacist Only module
          this.modules.splice(i,1);
          this.moduleNum--;
          this.moduleNum--;

          console.log("MODULE WAS SPLICED FOR THIS USER");

      }else if (this.foundPharmacistModule == true && ( modules[i].icourseID == 18913571 || modules[i].icourseID== 25904668)){// Add scoId here for Pharmacist Only module
        
        
      }

            this.moduleNum++;
        

        console.log("MODULE NUBMERS " + this.moduleNum);



        }

      },
      err => {
        console.log(err);
      });

      if(this.authService.getUserData() !== null){
        this.breezeSessionString = this.authService.getUserData().breezeSessionString;
        this.breezeSessionString = this.authService.getBreezeSessionString();
      }
  }


  ngOnDestroy() {
    //this.paramSub.unsubscribe();
  }



  checkBreezeQuotaSession(module){

    console.log('Going through Breeze Service');

    this.breezeService.checkBothQuotaAndSession(module, this.spinner, this.modalSessionTemp, this.modalQuotaTemp, this.modalRef, this.modalService)

  }

  callCloseModal(){

    console.log('Going through callCloseModal in Breeze Service')

    this.breezeService.closeModal();

  }


}



// WEBPACK FOOTER //
// ./src/app/featured-home/featured-home.component.ts